import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

import { getObjectRoute } from '@helpers/routerNavigation';
import { setToken } from '@store/onboarding/actions';
import { setRouter, hideSnackBar } from '@store/common/actions';
import { getTokenFromParams } from '@helpers/utils';

import CssBaseline from '@material-ui/core/CssBaseline';

import { SpinnerScreen, ModalScreen, SnackBarScreen } from '@screen';

const RedirectRouteByStatus = ({ match, children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const {
    router: { isAllowed, redirectTo },
  } = useSelector((state) => state.common);
  const { status, isMerchantProfile, legal_entity } = useSelector((state) => state.onboarding);
  const getPageForStatus = () => {
    const uri = match.url;
    const { isAllowed, redirectTo } = getObjectRoute(status, legal_entity, uri, isMerchantProfile);
    return { isAllowed, redirectTo };
  };

  const handleRoutes = () => {
    const routerObject = getPageForStatus();
    const token = getTokenFromParams(location);
    if (token) {
      dispatch(setToken(token));
    }
    dispatch(setRouter(routerObject));
  };

  useEffect(() => {
    handleRoutes();
    dispatch(hideSnackBar());

    return () => {
      dispatch(setRouter({ isAllowed: true, redirectTo: '' }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <CssBaseline />
      <SnackBarScreen />
      <ModalScreen />
      <SpinnerScreen />
      {isAllowed ? children : <Redirect to={redirectTo} />}
    </>
  );
};

RedirectRouteByStatus.propTypes = {
  redirectTo: PropTypes.string,
};

export default RedirectRouteByStatus;
